export default __webpack_public_path__ + "static/media/waiting2.a0371031.gif";